// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5826) return "js/app/5826.js";
	if (chunkId === 1330) return "js/app/1330.js";
	// return url for filenames based on template
	return undefined;
};